import { useEffect, useState } from 'react';
import { transformToQueryParams } from '../utils/utils';
import { axiosInstance } from '../utils/axiosInstance';
import { genericHandlerError } from './commonServices';

function useGet<T>(initValue: {
  url: string;
  defaultValue: any;
  queryParams?: any;
  transformData?: Function;
}): [result: T | any, makeRequest: Function, isLoading: boolean] {
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(initValue.defaultValue);
  const [error, setError] = useState({});

  useEffect(() => {
    genericHandlerError(error);
  }, [error]);

  const makeRequest = async (queryParams = initValue.queryParams || {}) => {
    try {
      //await setResult(initValue.defaultValue);
      await setIsLoading(true);
      const url = `${initValue.url}${transformToQueryParams(queryParams)}`;
      const preResult = await axiosInstance.get(url);
      await setResult(initValue.transformData ? initValue.transformData(preResult.data) : preResult.data);
      await setIsLoading(false);
    } catch (err) {
      await setError(err as any);
      await setIsLoading(false);
    }
  };

  return [result, makeRequest, isLoading];
}

export default useGet;
